import { render } from "./value.vue?vue&type=template&id=c900ee18&scoped=true&lang=pug"
import script from "./value.vue?vue&type=script&lang=js"
export * from "./value.vue?vue&type=script&lang=js"

import "./value.vue?vue&type=style&index=0&id=c900ee18&lang=scss&scoped=true"

import exportComponent from "../../../../../node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c900ee18"]])

export default __exports__